// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__REmGo","menuItem":"styles_menuItem__RQsFH","menuItemLink":"styles_menuItemLink__jQgcU","adaptiveMenu":"styles_adaptiveMenu__cYqZf"};